import { BodyPrimary, H5 } from '@liveauctioneers/hammer-ui-core/text';

import { ReviewComment as ReviewCommentType } from '@/types/Review';
import { Seller } from '@/types/Seller';

import { ReviewComment } from './ReviewComment';
import { ReviewFeedbackBar } from './ReviewFeedbackBar';

type Props = {
    comments: ReviewCommentType[];
    helpfulCount: number;
    review: string;
    reviewHeadline: string;
    reviewId: number;
    seller: Seller;
    statuses: string[];
    submitted: boolean;
};

export const ReviewAndComments = ({
    comments,
    helpfulCount,
    review,
    reviewHeadline,
    reviewId,
    seller,
    statuses,
}: Props) => {
    const publicComments = comments
        .filter((rc: ReviewCommentType) => rc.privacyStatus === 'public')
        .map((rc: ReviewCommentType, i: number) => {
            return (
                <ReviewComment
                    comment={rc}
                    key={i}
                    seller={seller}
                />
            );
        });

    const reviewTitle = reviewHeadline ? (
        <div className="max-w-[688px]">
            <H5>{reviewHeadline}</H5>
        </div>
    ) : null;
    const reviewTextContent = review ? (
        <div className="my-2xs max-w-[688px]">
            <BodyPrimary>{review}</BodyPrimary>
        </div>
    ) : null;

    return (
        <div className="flex flex-col">
            {reviewTitle}
            {reviewTextContent}
            {(review?.length > 0 || reviewHeadline?.length > 0) && (
                <ReviewFeedbackBar
                    helpfulCount={helpfulCount}
                    reviewId={reviewId}
                    statuses={statuses}
                />
            )}
            {publicComments.length ? publicComments : null}
        </div>
    );
};
